module.exports = __webpack_public_path__ + "img/id5.47f999a1.png";